'use strict';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var IsIpfs = require('is-ipfs');

var promisify = require('promisify-es6');

var streamToValueWithTransformer = require('../utils/stream-to-value-with-transformer');

var moduleConfig = require('../utils/module-config');

var cleanCID = require('../utils/clean-cid');

module.exports = function (arg) {
  var send = moduleConfig(arg);
  var refs = promisify(function (args, opts, callback) {
    if (typeof opts === 'function') {
      callback = opts;
      opts = {};
    }

    opts = module.exports.normalizeOpts(opts);

    try {
      args = module.exports.checkArgs(args);
    } catch (err) {
      return callback(err);
    }

    var transform = function transform(res, cb) {
      cb(null, res.map(function (r) {
        return {
          ref: r.Ref,
          err: r.Err
        };
      }));
    };

    var request = {
      args: args,
      path: 'refs',
      qs: opts
    };
    send(request, function (err, result) {
      if (err) {
        return callback(err);
      }

      streamToValueWithTransformer(result, transform, callback);
    });
  });
  refs.local = require('./refs-local')(arg);
  refs.localReadableStream = require('./refs-local-readable-stream')(arg);
  refs.localPullStream = require('./refs-local-pull-stream')(arg);
  return refs;
};

module.exports.checkArgs = function (args) {
  var isArray = Array.isArray(args);
  args = isArray ? args : [args];
  var res = [];

  var _iterator = _createForOfIteratorHelper(args),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var arg = _step.value;

      try {
        arg = cleanCID(arg);
      } catch (err) {
        if (!IsIpfs.ipfsPath(arg)) {
          throw err;
        }
      }

      res.push(arg);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return isArray ? res : res[0];
};

module.exports.normalizeOpts = function (opts) {
  opts = opts || {};

  if (typeof opts.maxDepth === 'number') {
    opts['max-depth'] = opts.maxDepth;
  }

  return opts;
};